import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin, Sprout } from 'lucide-react';

export const Footer: React.FC = () => {
  const [logoError, setLogoError] = useState(false);

  return (
    <footer id="contact-footer" className="bg-stone-900 text-stone-300 pt-20 pb-10 border-t-4 border-avo-main">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Brand */}
          <div className="space-y-6">
            <div className="flex flex-col items-start">
                {!logoError ? (
                     <img 
                        src="https://lh3.googleusercontent.com/d/1nElyiFHM8y4hVlChTDXZZ2an5ihGB10B" 
                        alt="Villa Avoils Logo" 
                        className="h-16 w-16 object-cover mb-4 rounded-full border-2 border-avo-gold/50"
                        onError={() => setLogoError(true)}
                    />
                ) : (
                    <div className="h-16 w-16 mb-4 bg-white/5 p-3 rounded-full flex items-center justify-center border border-white/10">
                        <Sprout className="text-white" size={32} />
                    </div>
                )}
               
                <span className="font-heading font-bold text-2xl text-white tracking-wide">
                VILLA AVOILS
                </span>
                <span className="text-xs uppercase tracking-widest text-avo-accent">
                International Limited
                </span>
            </div>
            <p className="text-sm leading-relaxed text-stone-400">
              Pioneering the green revolution in agriculture. Export-ready quality from the heart of Kenya.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-avo-main transition-colors"><Facebook size={20} /></a>
              <a href="#" className="hover:text-avo-main transition-colors"><Twitter size={20} /></a>
              <a href="#" className="hover:text-avo-main transition-colors"><Instagram size={20} /></a>
              <a href="#" className="hover:text-avo-main transition-colors"><Linkedin size={20} /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-6 font-heading">Company</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="hover:text-avo-main transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-avo-main transition-colors">About Us</Link></li>
              <li><Link to="/careers" className="hover:text-avo-main transition-colors">Careers</Link></li>
              <li><Link to="/contact" className="hover:text-avo-main transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-bold mb-6 font-heading">Products</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/products" className="hover:text-avo-main transition-colors">Avocado Oil</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold mb-6 font-heading">Contact Us</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-avo-main mt-0.5 flex-shrink-0" />
                <span>P.O Box 3169-10100<br/>Muruguru, Nyeri, Kenya</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-avo-main flex-shrink-0" />
                <span>0105662814</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-avo-main flex-shrink-0" />
                <span className="break-all">info@villaavoils.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-stone-400">
          <p>&copy; {new Date().getFullYear()} Villa Avoils International Limited. All rights reserved.</p>
          <p className="mt-2 md:mt-0">Designed for Sustainability.</p>
        </div>
      </div>
    </footer>
  );
};